<template>
  <div class="explain">
    <div class="explain-container">
      <h2>什么是学期数学掌握程度 ？</h2>
      <h3 class="mt-36">从国际公认理论出发的科学教育体系</h3>

      <ul>
        <li>a. 以知识掌握为决定因素：每个章节做题数量越多、正确率越高，该章节掌握度越高</li>
        <li>b. 以知识网络为关联依据：完成一道作业题，相关课节的掌握度均可能提升</li>
        <li>c. 以知识耗散为衰减尺度：参考国际公认的遗忘曲线公式，⻓期不做练习的知识点可能会下降</li>
      </ul>

      <h3 class="mt-36">基于全国四千万小学生大数据的AI评分</h3>

      <p>截止2018年10月份，作业盒子在全国已有超过40,000 ,000的小学学生用户使用，基于海量的作业数据，通过深度学习等方式，力图为学员评估最切合实际学习情况的掌握度分数</p>

      <h3 class="mt-36">逾十万数学老师正在使用的教学辅助工具</h3>

      <p>2018年秋季学期，全国超过100,000名数学老师正在使用作业盒子的数学掌握度数据，为孩子布置有针对性的智能作业</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "explain",
  created: function() {
    window.scrollTo(0, 0);
  }
};
</script>

<style lang="scss" scoped>
.explain {
  padding: 0.5rem 0.3rem 0.3rem 0.3rem;
  background-color: #f3dec7;
  min-height: 100vh;
  font-family: PingFangSC-Medium;
  &-container {
    background: #fff;
    box-shadow: 0 0.08rem 0.2rem 0 rgba(0, 0, 0, 0.08);
    border-radius: 0.16rem;
    padding: 0.5rem 0.3rem 0.3rem 0.3rem;
    h2 {
      font-size: 0.36rem;
      color: #916e4f;
      text-align: center;
    }
    h3 {
      font-size: 0.3rem;
      line-height: 0.5rem;
      color: #b37f51;
      text-align: center;
    }

    ul {
      li {
        font-size: 0.26rem;
        color: #56586a;
        line-height: 0.5rem;
        margin-top: 0.43rem;
      }
    }

    p {
      font-size: 0.26rem;
      color: #56586a;
      line-height: 0.5rem;
      color: #56586a;
      margin-top: 0.43rem;
    }
  }

  .mt-36 {
    margin-top: 0.36rem;
  }
}
</style>